/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number4SansDark = () => (
	<>
		<path
			fill={'#0D2A5E'}
			d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
		/>
		<path
			fill="white"
			d="M17.14 24.35V20.9H9.15002V18.1L15.78 7.66H20.69V17.77H22.84V20.9H20.69V24.35H17.13H17.14ZM17.14 10.8L12.63 17.76H17.14V10.8Z"
		/>
	</>
);

export default Number4SansDark;
